import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CodeShortcutSvg = function CodeShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A9912",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.845 16.33h.156l3.024-9.006h-1.062l-2.526 7.537q.265.709.408 1.469M7.66 11.002l1.416-.552V9.154L6.459 10.18q.635.364 1.2.822m12.588 1.494-5.322 2.064v-1.284l3.672-1.398-3.678-1.428V9.154l5.328 2.088z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var CodeShortcut = function CodeShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CodeShortcutSvg
  }));
};